const OVERRIDE_WIX_AD = 'override-wix-ad';

export { OVERRIDE_WIX_AD };
